module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcomeViewApprove"
  }, [(_vm.componentsList.length) ? _c('div', _vm._l((_vm.componentsList), function(item) {
    return _c('div', {
      key: item.bizItemId,
      staticClass: "content",
      on: {
        "click": function($event) {
          return _vm.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "head",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "center",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))])])
  }), 0) : _c('div', {
    staticClass: "message"
  }, [_vm._v("暂无消息")]), _vm._v(" "), (_vm.componentsList.length >= 3) ? _c('div', {
    staticClass: "more"
  }, [_vm._v("查看更多"), _c('i', {
    staticClass: "el-icon-arrow-right"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3444ba2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcomeViewApprove.vue
// module id = 1656
// module chunks = 471